<template>
    <div class="select-wrapper">
        <div class="label">{{ label }}</div>
        <div class="custom-select">
            <div class="selected">
                {{ (selected && selected.name) || "尚未加入任何群組" }}
            </div>
            <select v-model="selected" @change="onChange(selected)">
                <option
                    v-for="(option, i) in options"
                    :key="`option${i}`"
                    :value="option"
                >
                    {{ option.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        options: Array,
        initSelected: Object,
    },
    data() {
        return {
            selected: null,
        };
    },
    created() {
        this.selected = this.initSelected;
    },
    methods: {
        onChange(val) {
            this.selected = val;
            this.$emit('change', this.selected.name);
        },
    },
};
</script>

<style lang="scss" scoped>
.select-wrapper {
    font-size: 1.5em;
    margin-bottom: 30px;
    width: 100%;
}
.label {
    color: #064269;
    font-weight: bold;
    margin-bottom: 10px;
    .required {
        color: #ed6f6f;
    }
}
.custom-select {
    position: relative;
    height: 52.5px;
    background-color: #ffffff;
    box-sizing: border-box;
    background-color: #cbebff;
    border-radius: 18.8px;
    box-sizing: border-box;
    display: flex;
    .selected {
        color: #4683bc;
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        font-weight: bold;
        text-align: center;
    }
    select {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        &:focus {
            border: 0;
            outline: 0px;
        }
        &:focus-visible {
            outline: 0px;
        }
    }
}
</style>
